/// <amd-module name="Feed/Common/Services/FeedPerformanceService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";

import { PerfScenarios } from "Feed/Common/Constants/Constants";

export interface IFeedPerformanceService extends IVssService {
    startScenario(scenarioName: string, isPageInteractive?: boolean): IVssScenario;

    endScenario(scenario: string | IVssScenario, isPageInteractive?: boolean): void;

    split(timingName: string, scenarioName?: string): void;
}

export class FeedPerformanceService extends VssService implements IFeedPerformanceService {
    public split(timingName: string, scenarioName?: string | undefined): void {
        this.PerformanceService.addSplitTiming(timingName, scenarioName);
    }

    public startScenario(scenarioName: string, isPageInteractive: boolean = false): IVssScenario {
        return this.PerformanceService.startScenario(scenarioName, isPageInteractive);
    }

    public endScenario(scenario: string | IVssScenario, isPageInteractive: boolean = false): void {
        let scenarioName: string = "";
        if (typeof scenario == "object") {
            scenarioName = scenario.scenarioName;
        } else {
            scenarioName = scenario;
        }
        this.PerformanceService.endScenario(PerfScenarios.Area, scenarioName, isPageInteractive);
    }

    private get PerformanceService(): IVssPerformanceService {
        return this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }
}

Services.add("IFeedPerformanceService", { serviceFactory: FeedPerformanceService });
